import JsonNotionRenderer from "./JsonNotionRenderer";
import "./notion-renderer.scss";

/**
 * Read-only renderer for Notion/Tiptap JSON documents.
 *
 * This is now a lightweight wrapper around `JsonNotionRenderer`, a custom
 * recursive renderer that walks the document JSON directly — no Tiptap /
 * ProseMirror runtime is loaded.
 *
 * Props:
 *  - content: Tiptap JSON doc (object) or HTML string to display
 *  - className: extra class applied to the root element
 *  - lessonId: optional lesson id, used to persist quiz answers
 */
function NotionRenderer({ content = null, className = "", lessonId = "" }) {
  return (
    <div className={`notion-renderer ${className}`}>
      <div className="notion-renderer-surface">
        <JsonNotionRenderer content={content} lessonId={lessonId} />
      </div>
    </div>
  );
}

export default NotionRenderer;
